import { ColumnMetadata } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { Emdash } from "~/components/Punctuation";

export const TICKER_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    slug: AssetColumns.ticker,
    sortsOn: AssetColumns.ticker,
    label: "Ticker",
    // tooltip: CatalogReferenceDataSlugs.ticker,
    type: "string",
    width: 100,
    render: (item) => {
        if (item.isAsset) {
            return <span className="font-mono">{item.ticker}</span>;
        }

        return <Emdash />;
    },
};
